import { buildSelector } from '@/shared/lib/store';

export const [useSessionAccessToken] = buildSelector(
    (state) => state.session.accessToken,
);
